import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=46ddebe7&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=46ddebe7&prod&lang=scss&scoped=true"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=46ddebe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ddebe7",
  null
  
)

export default component.exports